
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/insurance-resources/insurer-resources",
      function () {
        return require("private-next-pages/resources/insurance-resources/insurer-resources/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/insurance-resources/insurer-resources"])
      });
    }
  